import { render, staticRenderFns } from "./viewMessage.vue?vue&type=template&id=712ac140&scoped=true&"
import script from "./viewMessage.vue?vue&type=script&lang=js&"
export * from "./viewMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712ac140",
  null
  
)

export default component.exports